<ngx-skeleton-loader
  count="1"
  appearance="line"
  [theme]="{
    'border-radius': borderRadius,
    'height': height,
    'width': width,
    'min-width': minWidth,
    'margin':'0px'
  }">
</ngx-skeleton-loader>
